<template>
  <b-table
    v-show="filteredItems.length > 0"
    outlined
    striped
    hover
    :fields="fields"
    :items="filteredItems"
  >
    <template #cell(title)="row">
      <a
        target="_blank"
        class="p-0 m-0 border-0 text-left"
        :href="row.item.url"
      >
        {{ row.item.title }}
        <font-awesome-icon :icon="['fas', 'external-link-alt']" size="1x" />
      </a>
    </template>
    <template #cell(summary)="row">
      {{ row.item.summary }}
    </template>
  </b-table>
</template>

<script>
export default {
  name: 'RssNotificationsList',
  props: { fields: Array, filteredItems: Array },
};
</script>

<style scoped></style>
